@if (loading) {
  <div class="loading-spinner">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <div [innerHTML]="content"></div>
}
